import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import image1 from "assets/img/07012019003.png";
// import image101 from "assets/img/02dec1918.png";
// import image102 from "assets/img/14122018-2.png";
// import imageIso from "assets/img/27000family.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={10}>
              <Card>
                <CardBody>
                  <span style={{ marginBottom: 0 }}>07 January 2019, 08.00 PM</span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>PDAM TIRTA MUSI: Pelatihan Sistem Manajemen Mutu ISO 9001:2015 </b></h2>
                  <span style={{ fontSize: 18 }}>
                    <br />
                    <center>
                      <img src={image1} alt="Images" style={{ width: 624, height: 404, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                      PDAM TIRTA MUSI merupakan Perusahaan Air Bersih yang berada di kota Palembang, Sumatera Selatan. Perusahaan air bersih ini menjangkau seluruh wilayah kota Palembang dengan jumlah pelangan saat ini 281.462. PDAM Tirta Musi adalah satu-satunya sumber air bersih yang layak untuk minum dan masak bagi sebagian besar penduduk kota Palembang. Perusahaan ini memiliki 9 kantor unit pelayanan.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Saat ini PDAM TIRTA MUSI sudah membentuk perwakilan manajemen (MR) untuk menuju proses sertifikasi standar internasional sistem mutu manajemen ISO 9001:2015. Pada tanggal 2 Mei sampai dengan tanggal 4 Mei 2018, PDAM Tirta Musi memberikan kepercayaan kepada PT. Sandton Sukses Bersama untuk memberikan pelatihan kepada PDAM TIRTA MUSI. Pelatihan ini berguna untuk meningkatkan kesadaran dan pemahaman para karyawan agar mulai menerapkan aturan standar internasional ISO 9001:2015 dalam sistem manajemennya.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Dengan adanya pelatihan ini PDAM TIRTA MUSI telah siap untuk maju tahap selanjutnya yaitu sertifikasi ISO 9001:2015, demi terciptanya perusahaan yang diakui standar internasional dan meningkatkan kepuasan pelanggan serta meningkatkan mutu pelayanan.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Terima kasih kepada PDAM TIRTA MUSI telah menyambut kami dengan hangat dan percaya kepada kami dalam memberikan pelatihan kepada PDAM TIRTA MUSI. Sesuai dengan moto kami <b>“Inspiring World Quality System”</b>, semoga pelatihan yang sudah berlangsung memberi manfaat dan semakin siap untuk proses selanjutnya. Semoga PDAM TIRTA MUSI semakin memberikan pelayanan yang terbaik untuk masyarakat kota Palembang.
                  </p>
                    <br />
                  </span>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div >
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/News/Sections/ProductSection.6.jsx